// @flow

import { type UserInputValidationError } from '@tectonics/prs/validation';

const ZA_PHONE_REGEX = /^0\d{9}$/;

export function validateSouthAfricanPhoneNumber(phoneNumberValue: string): ?UserInputValidationError {
  if (!phoneNumberValue || !phoneNumberValue.trim()) {
    return { id: 'empty' };
  } else if (!ZA_PHONE_REGEX.test(phoneNumberValue)) {
    return { id: 'invalid-pattern' };
  }
}

export function validateSouthAfricanPhoneNumberEmpty(phoneNumberValue: string): ?UserInputValidationError {
  if (!phoneNumberValue || !phoneNumberValue.trim() || !parseInt(phoneNumberValue)) {
    return { id: 'empty' };
  }
}
